<template>
  <div
    id="clock"
    :class="{
      'pulse animated': clockIsRunning,
      'pulseStrong animated': !clockIsRunning
    }"
  >
    <div
      class="ui center aligned very padded segment"
      :class="{ orange: clockIsRunning, attached: showControls }"
    >
      <div class="ui huge statistic" :class="{ orange: clockIsRunning }">
        <div class="value">{{ activePlayer.score }}</div>
        <div class="label">{{ activePlayer.name | smartTruncate }}</div>
      </div>
    </div>
    <div
      class="ui icon massive red bottom attached button"
      @click.stop="stopClock"
      v-if="showControls && clockIsRunning"
    >
      Stop Klok [SPATIE]
    </div>
    <div
      class="ui icon massive green bottom attached button"
      :class="{ loading, disabled: loading }"
      @click.stop="startClock"
      v-else-if="showControls"
    >
      Start Klok [SPATIE]
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUNDS } from '@/config';
import sounds from '@/sounds';
import Mousetrap from 'mousetrap';
import alertify from 'alertify.js';

export default {
  name: 'clock',
  props: {
    showControls: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters([
      'activePlayer',
      'clockIsRunning',
      'isHost',
      'isPremium',
      'inFinale'
    ]),
    clockStarted() {
      return typeof this.$store.state.game.clockStarted === 'number';
    }
  },
  watch: {
    clockStarted: function(ticking) {
      if (ticking) this.startTicking();
      else this.stopTicking();
    }
  },
  created() {
    if (this.clockStarted) {
      this.startTicking();
    }
    // -> start or stop the clock by pressing the SPACE key
    this.addKeyboardShortcuts();
  },
  beforeDestroy() {
    this.stopTicking();
  },
  methods: {
    startClock() {
      if (!this.loading) {
        this.loading = true;
        this.$store.dispatch('startClockForActivePlayer').then(() => {
          this.$store.dispatch('syncGame');
          this.loading = false;
        });
      }
    },
    stopClock() {
      this.$store.dispatch(
        `${ROUNDS[this.$store.state.game.currentRound].slug}/stopClock`,
        this.timeInSeconds
      );
      this.$store.dispatch('syncGame');
    },
    startTicking() {
      const playerId = this.activePlayer.id;
      this.intervalId = setInterval(() => {
        this.$store.commit('COUNTDOWN_SCORE_PLAYER', playerId, { root: true });
        if (this.activePlayer.score <= 0 && this.inFinale) {
          this.$store.dispatch('finale/gameOver', {
            winnerId: this.$store.getters['finale/opponent'].id,
            loserId: playerId
          });
          if (this.isHost) this.$store.dispatch('syncGame');
        }
      }, 1000);
      sounds.play(sounds.AUDIO.CLOCK_TICKING);
    },
    stopTicking() {
      if (this.intervalId) clearInterval(this.intervalId);
      sounds.play(sounds.AUDIO.CLOCK_END);
      sounds.pause(sounds.AUDIO.CLOCK_TICKING);
    },
    addKeyboardShortcuts() {
      // Whatever start/stop control is there, we blindly click it.
      Mousetrap.bind('space', () => {
        if (this.isPremium) {
          const clockButton = document.querySelector('#clock .button');
          if (clockButton) clockButton.click();
        } else {
          alertify.log(
            'Deze sneltoets is niet mogelijk in de gratis basisversie.'
          );
        }
        return false;
      });
    }
  }
};
</script>

<style scoped>
.ui.statistic > .value {
  font-size: 12rem !important;
}
.ui.statistic > .label {
  font-size: 3rem !important;
}
@media only screen and (max-width: 991px) {
  .ui.statistic > .value {
    font-size: 8rem !important;
  }
  .ui.statistic > .label {
    font-size: 2rem !important;
  }
}
</style>
